import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FaPlus } from 'react-icons/fa';

import { BOUTON_PRINCIPAL, BOUTON_SECONDAIRE } from '../Employee/organigrammeOutils';
import { CLASSE_CHAMP } from './departOutils';

/**
 * « Ajouter une convocation » (C39 `etapes/ajouter`), en place dans le volet.
 * Il ne parle pas à l'API : `onEnvoyer({ echeance, heure, lieu })` rend une promesse
 * de booléen (succès : formulaire vidé et replié ; refus : saisie conservée).
 * Aucune borne sur l'échéance (Odoo accepte une date passée) et pas de `step` sur
 * l'heure : le champ rendrait des secondes que le contrat ne prévoit pas.
 */
function FormulaireConvocation({ bloque, onEnvoyer }) {
  const { t } = useTranslation();
  const [ouvert, setOuvert] = useState(false);
  const [echeance, setEcheance] = useState('');
  const [heure, setHeure] = useState('');
  const [lieu, setLieu] = useState('');
  const [envoi, setEnvoi] = useState(false);
  // Garde synchrone : deux clics dans le même tick passent avant tout re-rendu.
  const enVol = useRef(false);

  // Même règle qu'Odoo (`_texte`) : un lieu d'espaces est un lieu absent.
  const complet = Boolean(echeance && heure && lieu.trim());

  const envoyer = async (evenement) => {
    evenement.preventDefault();
    if (enVol.current || bloque || !complet) return;
    enVol.current = true;
    setEnvoi(true);
    const succes = await onEnvoyer({ echeance, heure, lieu });
    enVol.current = false;
    setEnvoi(false);
    if (succes) {
      setOuvert(false);
      setEcheance('');
      setHeure('');
      setLieu('');
    }
  };

  if (!ouvert) {
    return (
      <button type="button" data-testid="convocation-ajouter" className={BOUTON_SECONDAIRE} onClick={() => setOuvert(true)}>
        <FaPlus size={12} /> {t('discipline.ajouterConvocation')}
      </button>
    );
  }

  return (
    <form onSubmit={envoyer} className="space-y-3">
      <label className="block font-medium">
        {t('discipline.echeanceEntretien')}
        <input type="date" data-testid="convocation-echeance" value={echeance}
          onChange={(e) => setEcheance(e.target.value)} className={CLASSE_CHAMP} />
      </label>
      <label className="block font-medium">
        {t('discipline.heure')}
        <input type="time" data-testid="convocation-heure" value={heure}
          onChange={(e) => setHeure(e.target.value)} className={CLASSE_CHAMP} />
      </label>
      <label className="block font-medium">
        {t('discipline.lieu')}
        <input type="text" data-testid="convocation-lieu" value={lieu}
          onChange={(e) => setLieu(e.target.value)} className={CLASSE_CHAMP} />
      </label>
      <button type="submit" data-testid="convocation-envoyer" disabled={!complet || bloque || envoi} className={BOUTON_PRINCIPAL}>
        {t('discipline.envoyerConvocation')}
      </button>
    </form>
  );
}

FormulaireConvocation.propTypes = {
  bloque: PropTypes.bool,
  onEnvoyer: PropTypes.func.isRequired,
};

export default FormulaireConvocation;
